module.exports = require("./src/gatsby/browser/index.tsx");
